import { useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import dialogStyles from '../../Dialog.module.css'
import codegenPromptUrl from './docs/codegen-prompt.md'

/*
 * The prompt is a static asset rather than a string literal so that updating it
 * is a file replacement: it is full of backticks, backslashes and ${, all of
 * which a template literal would need escaped by hand.
 */
export function CodeWidgetHtmlHelp() {
  const [prompt, setPrompt] = useState<string | null>(null)
  const [loadFailed, setLoadFailed] = useState(false)
  const [copyState, setCopyState] = useState<'idle' | 'copied' | 'failed'>('idle')

  useEffect(() => {
    fetch(codegenPromptUrl)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(setPrompt, () => setLoadFailed(true))
  }, [])

  const copy = (text: string) => navigator.clipboard.writeText(text).then(
    () => setCopyState('copied'),
    () => setCopyState('failed'),
  ).finally(() => setTimeout(() => setCopyState('idle'), 2000))

  if (loadFailed) return <p>The prompt could not be loaded.</p>
  if (prompt == null) return <p>Loading prompt…</p>

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-4">
        <p className="m-0">Give this prompt to your AI assistant, followed by what the page should do.</p>
        <Button color="primary" className="shrink-0" onClick={() => copy(prompt)}>
          {copyState === 'copied' ? 'Copied' : copyState === 'failed' ? 'Copy failed' : 'Copy prompt'}
        </Button>
      </div>
      <pre className={`m-0 max-h-[360px] overflow-auto whitespace-pre-wrap select-all rounded-md border border-neutral-600 p-3 text-sm text-neutral-300 ${dialogStyles['dialog-scrollbar']}`}>
        {prompt}
      </pre>
    </div>
  )
}
